module.exports = "https://static.zego.com/_next/static/images/Wakam-fe3d948ae16f2261cba6e7eb5de4c2a8.svg";